/**
 * Haelt Tabelle und Bild der Produktdetails am gewaehlten Varianten stand.
 *
 * Beide Datensaetze liegen dedupliziert als JSON neben dem Markup: gleiche
 * Werte teilen sich einen Eintrag, die Zuordnung laeuft ueber Varianten-ID.
 * Ohne Datenliste passiert nichts - dann gibt es zwischen den Varianten
 * schlicht keinen Unterschied.
 */
(function () {
  'use strict';

  var ATTR = 'data-veynou-specs';

  function parse(island) {
    if (!island) return null;
    try {
      return JSON.parse(island.textContent);
    } catch (error) {
      console.warn('[veynou-specs] Datensatz nicht lesbar', error);
      return null;
    }
  }

  function cached(node, key, island) {
    if (node[key] === undefined) node[key] = parse(island);
    return node[key];
  }

  function makeRow(label, value, flag) {
    var row = document.createElement('tr');
    var head = document.createElement('th');
    var cell = document.createElement('td');

    head.setAttribute('scope', 'row');
    head.textContent = label;
    cell.textContent = value;
    if (flag) row.setAttribute(flag, '');

    row.appendChild(head);
    row.appendChild(cell);
    return row;
  }

  function renderRows(tbody, data, index, variantId) {
    var values = data.sets[index];
    if (!values) return;

    var rows = document.createDocumentFragment();

    data.labels.forEach(function (label, position) {
      if (values[position]) {
        rows.appendChild(makeRow(label, values[position]));
      }
    });

    // Gewaehlte Groesse kommt aus der Varianten-Option, nicht aus dem Wertesatz.
    if (data.sizeLabel && data.sizes) {
      var size = data.sizes[String(variantId)];
      if (size) {
        rows.appendChild(makeRow(data.sizeLabel, size, ATTR + '-size'));
      }
    }

    tbody.classList.add('is-swapping');
    window.requestAnimationFrame(function () {
      while (tbody.firstChild) tbody.removeChild(tbody.firstChild);
      tbody.appendChild(rows);
      tbody.classList.remove('is-swapping');
    });
  }

  function updateTables(variantId) {
    document.querySelectorAll('[' + ATTR + ']').forEach(function (table) {
      var data = cached(table, 'veynouSpecs', table.parentNode.querySelector('[' + ATTR + '-data]'));
      if (!data) return;

      var index = data.map[String(variantId)];
      if (index === undefined) return;

      // Nicht auf den Wertesatz pruefen: bei Ringen bleibt der gleich,
      // waehrend sich die gewaehlte Groesse aendert.
      if (String(variantId) === table.veynouSpecsVariant) return;

      var tbody = table.querySelector('[' + ATTR + '-dynamic]');
      if (!tbody) return;

      table.veynouSpecsVariant = String(variantId);
      renderRows(tbody, data, index, variantId);
    });
  }

  function updateImages(variantId) {
    document.querySelectorAll('[' + ATTR + '-image-data]').forEach(function (island) {
      var data = cached(island, 'veynouImages', island);
      if (!data) return;

      var figure = island.parentNode.querySelector('[' + ATTR + '-figure]');
      if (!figure) return;

      var index = data.map[String(variantId)];
      if (index === undefined) return;

      var source = data.sources[index];
      var wrapper = figure.closest('.veynou-specs');

      // Variante ohne Bild: Tabelle nimmt die volle Breite ein.
      if (!source) {
        figure.hidden = true;
        if (wrapper) wrapper.classList.remove('veynou-specs--split');
        return;
      }

      var image = figure.querySelector('img');
      if (image) {
        image.setAttribute('src', source.src);
        image.setAttribute('srcset', source.srcset);
        image.setAttribute('alt', source.alt || '');
      }

      figure.hidden = false;
      if (wrapper) wrapper.classList.add('veynou-specs--split');
    });
  }

  function update(variantId) {
    if (!variantId) return;
    updateTables(variantId);
    updateImages(variantId);
  }

  // Kanal 1: CustomEvent aus global.js
  document.addEventListener('variant:change', function (event) {
    update(event.detail && event.detail.variant && event.detail.variant.id);
  });

  // Kanal 2: PubSub aus product-info.js, falls dort der Wechsel entsteht
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      update(event && event.data && event.data.variant && event.data.variant.id);
    });
  }

  // Kanal 3: Direktaufruf mit ?variant= in der URL, sowie nach Section-Rerender
  function syncFromUrl() {
    update(new URLSearchParams(window.location.search).get('variant'));
  }

  document.addEventListener('product-info:loaded', syncFromUrl);
  document.addEventListener('productInfo:loaded', syncFromUrl);
  syncFromUrl();
})();
